import React from 'react';
import { useParams } from 'react-router-dom';

const ListingDetails = () => {
    const { id } = useParams();

    return (
        <div>
            <h1>Listing Details</h1>
            <div style={{ marginTop: '1rem' }}>
                <p>Loading listing {id}...</p>
                <div style={{ marginTop: '2rem' }}>
                    <h2>Description</h2>
                    <p>Coming soon...</p>
                </div>
                <div style={{ marginTop: '2rem' }}>
                    <h2>Seller Information</h2>
                    <p>Coming soon...</p>
                </div>
                <div style={{ marginTop: '2rem' }}>
                    <h2>Make an Offer</h2>
                    <p>Coming soon...</p>
                </div>
            </div>
        </div>
    );
};

export default ListingDetails; 